<template>
  <div class="w-[800px] mx-auto h-[800px] m-4" ref="appcparent">
    <LegendAPP @download="$emit('makereport')" ref="legend" />

    <div class="fixed left-0 flex flex-col gap-y-2 top-32 h-4/6">
      <liste-acteurs
        @itemhover="focusHovered"
        @itemrelease="hovered = null"
        :items="circles"
      />

      <FiltreAPP v-if="circle" @filterupdated="applyFilters" :items="circles" />
    </div>

    <div class="w-full h-full" ref="diagram">
      <div class="absolute inset-0 z-20 bg-opacity-40">
        <div
          :style="{
            top: radius + 'px',
            left: radius + 'px',
            height: spacing * 2 + 'px',
            width: spacing * 2 + 'px',
            fontSize: spacing / 5 + 'px'
          }"
          class="
          z-50
            group
            animate-animated animate-delay-1s animate-faster animate-fadeIn
            absolute
            flex
            translate-x-[-50%] translate-y-[-50%]
            items-center
            justify-center
            ring-2 ring-base-100
            text-2xl
            font-bold
            uppercase
            transition-all
            transform
            rounded-full
            cursor-pointer
            duration-1000
            delay-75
          hover:scale-[0.9] hover:bg-primary-focus
            bg-red-700
            text-primary-content
          "
        >
          <span class="text-center"
            >Objectif <br />
            Poursuivi</span
          >

          <div
            class="
              group-hover:block group-hover:pointer-events-auto
              rounded-box
              w-64
              ml-2
              transition-all
              group-hover:animate-animated group-hover:animate-fadeInRight
              absolute
              hidden
              pointer-events-none
              z-[100]
              bg-base-200
              text-base-content
              translate-y-[-50%]
              p-2
              top-1/2
              left-32
              ring-2
              text-sm
              group-hover:scale-[1.4]
            "
          >
            <span class="block text-sm font-bold text-center"> Objectif </span>
            <div class="text-sm">
              {{ currentFolder?.result }}
            </div>
          </div>
        </div>

        <template v-for="(item, type) in filteredCircles" :key="type">
          <APPBullet
            v-if="getPosition(item)"
            @click="emitItem(item)"
            :item="item"
            :shouldhover="hovered && item.id == hovered.id"
            :position="getPosition(item)"
            :spacing="spacing"
          />
        </template>
      </div>
      <canvas ref="appc" class="z-0 animate-animated animate-zoomIn"></canvas>
    </div>
  </div>
</template>

<script>
import LegendAPP from "@/components/APPC/LegendAPP.vue";
import APPBullet from "@/components/APPC/APPBullet.vue";
import ListeActeurs from "@/components/APPC/ListeActeurs.vue";
import FiltreAPP from "@/components/APPC/FiltreAPP.vue";
import globalMixins from "@/utils/mixins/mixin.js";
import * as htmlToImage from "html-to-image";
export default {
  name: "Diagram",
  mixins: [globalMixins],
  components: { LegendAPP, APPBullet, ListeActeurs, FiltreAPP },
  props: {
    circles: Array
  },
  data() {
    return {
      circle: 0,
      vueCanvas: null,
      circlePositionCache: [],
      hovered: null,
      width: 0,
      height: 0,
      distance: 60,
      vals: [5, 4, 3],
      colors: [
        "rgba(0,91,255,0.6)",
        "rgba(0,91,255,0.4)",
        "rgba(0,91,255,0.2)",
        "rgba(185,230,226,0.5)",

        "rgba(241,250,249,0.5)"
      ],
      lineColor: "rgb(255,60,60)",
      ballColor: "rgb(60,255,60)",
      filters: null
    };
  },

  computed: {
    filteredCircles() {
      if (!this.filters) return this.circles;

      return this.circles.filter(
        x =>
          this.filters.type.includes(x.type.id) &&
          this.filters.implication.includes(x.implication.id) &&
          this.filters.influence.includes(x.influence.id)
      );
    },
    typesGroup() {
      return window._.groupBy(this.circles, function(circle) {
        return circle.type.id;
      });
    },
    radius() {
      return this.height / 2;
    },

    spacing() {
      return this.radius / 6;
    }
  },

  created() {
    // Setup a timer
    var timeout;
    var self = this;
    window.addEventListener(
      "resize",
      function() {
        console.log("no debounce");

        // If there's a timer, cancel it
        if (timeout) {
          this.clearTimeout(timeout);
        }

        // Setup the new requestAnimationFrame()
        timeout = setTimeout(self.drawAll, 400);
      },
      false
    );
  },
  unmounted() {
    window.removeEventListener("resize", this.drawAll);
  },

  mounted() {
    this.drawAll();
  },

  methods: {
    emitItem(item) {
      this.$emit("updatedcategory", item);
    },
    applyFilters(filters) {
      this.filters = filters;
    },
    focusHovered(e) {
      this.hovered = e;
    },
    async downloadImage() {
      var dataUrl = await htmlToImage.toPng(this.$refs.diagram);
      var dataUrl2 = await htmlToImage.toPng(
        this.$refs.legend.getLengendElement()
      );

      var link = document.createElement("a");
      link.download = "relation-diagram.jpeg";
      link.href = dataUrl;
      var el = this.$refs.legend.getLengendElement();
      var rect = el.getBoundingClientRect();
      return {
        data: dataUrl,
        legend: dataUrl2,
        width: (rect.width || el.offsetWidth) * 0.2645833333,
        height: (rect.height || el.offsetHeight) * 0.2645833333,
        title: "Analyse Relationnel des acteurs"
      };
    },

    drawAll() {
      if (!this.circles || !this.circles.length) {
        /*   console.log("No circles doing nothing"); */
        return;
      }
      this.circlePositionCache = [];

      console.log("Circles drawings");
      var c = this.$refs.appc;
      var par = this.$refs.appcparent;
      this.width = Math.min(window.innerHeight, window.innerWidth) - 20;
      this.height = this.width;
      par.style.width = this.width + "px";
      par.style.height = this.width + "px";
      var ctx = c.getContext("2d");
      ctx.canvas.width = this.width;
      ctx.canvas.height = this.height;
      this.vueCanvas = ctx;

      // this.simulateVals();

      //this.simulateVals();
      for (let index = 0; index < 5; index++) {
        this.circle = index;
        this.drawCircle();
      }
      this.simulateVals();

      //this.circle = 5;
      //this.drawCircle();
    },
    getPosition(item) {
      return this.circlePositionCache.filter(x => x.item.id == item.id)[0];
    },
    groupByInfluence(items) {
      return window._.groupBy(items, function(circle) {
        return circle.influence.id;
      });
    },
    simulateVals() {
      var lastAngle = 0;
      const total = this.circles.length;
      //console.log("Total is :" + total);
      //console.log(this.typesGroup);
      for (const [key, item] of Object.entries(this.typesGroup)) {
        /*    console.log("Type " + key);
        console.log(item); */
        var prob = item.length / total;
        var angle = prob * Math.PI * 2;

        // console.log("Item is :" + item.length + "/" + total + " = " + prob);
        //console.log(key - 1);
        this.drawFillCircle(
          this.colors[parseInt(key) - 1],
          lastAngle,
          lastAngle + angle
        );
        this.drawCirclesForAngle(angle, lastAngle, item);
        lastAngle += angle;
      }
    },
    drawCircle(color = this.lineColor, stroke = true) {
      if (this.circle > 5) return;
      if (this.circle == 5 && stroke) {
        this.drawCircle(this.lineColor, false);
        return;
      }
      this.vueCanvas.beginPath();
      if (this.circle < 5 && this.circle != 0) {
        this.vueCanvas.shadowColor = "rgb(255,120,120)";
        this.vueCanvas.shadowBlur = 10;
        this.vueCanvas.shadowOffsetX = 0;
        this.vueCanvas.shadowOffsetY = 0;
      }
      this.vueCanvas.beginPath();
      this.vueCanvas.strokeStyle = color;
      this.vueCanvas.fillStyle = color;
      this.vueCanvas.arc(
        this.radius,
        this.radius,
        this.getCircleRadius(this.circle++),
        0,
        2 * Math.PI
      );
      if (stroke) {
        this.vueCanvas.fillStyle = "#fff";
        this.vueCanvas.strokeStyle = "rgb(255,60,60)";
        this.vueCanvas.lineWidth = 2;
        this.vueCanvas.fill();
        this.vueCanvas.stroke();
      } else {
        this.vueCanvas.fill();
      }
      this.vueCanvas.shadowColor = "transparent";
    },

    drawFillCircle(color, start, end) {
      /*   console.log(
        "Je dessine les segment avec " +
          color +
          " Je commence à : " +
          start +
          " et je m'arrete à: " +
          end
      ); */
      this.vueCanvas.beginPath();
      this.vueCanvas.fillStyle = color;
      this.vueCanvas.moveTo(this.radius, this.radius);
      this.vueCanvas.arc(this.radius, this.radius, this.radius, start, end);
      this.vueCanvas.lineTo(this.radius, this.radius);
      this.vueCanvas.fill();
    },

    //Dessiner les circles pour un type (une sections)
    drawCirclesForAngle(angle, offset, circles) {
      var circlePositionCache = [...this.circlePositionCache];
      //Recuperer  par groupe d'influence (groupe de ligne)
      const lines = window._.groupBy(circles, function(circle) {
        return circle.influence.id;
      });
      for (const [lineNumber, item] of Object.entries(lines)) {
        console.log("Nous somme dans l'influence", lineNumber);
        console.log(item.length);
        console.log(angle);
        var angleSpacing = angle / (item.length + 1);
        console.log("Angle Spacing of " + lineNumber + " = " + angleSpacing);
        for (let index = 0; index < item.length; index++) {
          var x = Math.cos(offset + angleSpacing * (index + 1));
          var y = Math.sin(offset + angleSpacing * (index + 1));

          //this.drawCircleItem(this.ballColor, 5 - lineNumber, x, y);
          circlePositionCache.push({
            item: item[index],
            x: this.radius + x * this.getCircleRadius(5 - lineNumber),
            y: this.radius + y * this.getCircleRadius(5 - lineNumber)
          });
        }
      }

      this.circlePositionCache = circlePositionCache;
    },

    drawCircleItem(color, level, x, y) {
      //console.log("Je dessin " + color + " " + level + " " + x + " " + y);
      this.vueCanvas.beginPath();
      this.vueCanvas.fillStyle = color;
      this.vueCanvas.moveTo(0, 0);
      this.vueCanvas.arc(
        this.radius + x * this.getCircleRadius(level),
        this.radius + y * this.getCircleRadius(level),
        20,
        0,
        2 * Math.PI
      );
      this.vueCanvas.fill();

      this.vueCanvas.beginPath();
      this.vueCanvas.fillStyle = "#000";
      this.vueCanvas.arc(
        this.radius + x * this.getCircleRadius(level) + 12,
        this.radius + y * this.getCircleRadius(level) - 12,
        10,
        0,
        2 * Math.PI
      );
      this.vueCanvas.fill();
    },

    getCircleRadius(circle) {
      return this.radius - this.spacing * circle;
    },

    clearRect() {
      // clear canvas
      this.vueCanvas.clearRect(0, 0, 400, 200);

      // draw rect
      this.vueCanvas.beginPath();
      this.vueCanvas.rect(20, 20, this.rectWidth, 100);
      this.vueCanvas.stroke();
    },
    drawRect() {
      this.vueCanvas.moveTo(0, 0);
      this.vueCanvas.lineTo(200, 100);
      this.vueCanvas.stroke();
    },
    addWidth() {
      this.rectWidth += 10;
      this.drawRect();
    },
    subWidth() {
      this.rectWidth -= 10;
      this.drawRect();
    }
  }
};
</script>

<style scoped></style>>
